module.exports = __webpack_public_path__ + "img/HIGHT.f54dfcb9.svg";